import { useChat } from "../contexts/ChatContext";
import { useTransientVisibility } from "../../fusion/Contexts/VisualContext";
import { ReactComponent as IconCloseSquare } from "../../../images/cancel.svg";

import { Button, Modal } from "cai-fusion";

const DeleteChatModal = () => {
    const { chat, deleteChat } = useChat();
    const { visibilityStates, hide } = useTransientVisibility();

    return (
        <Modal
            id="delete-modal"
            isHidden={ !visibilityStates.DeleteChatModal }
            clickOutsideToClose={ true }
            title="Delete Chat"
            onClose={(e) => {
                hide('DeleteChatModal');
                e.preventDefault();
            }}
            actions={
                <>
                    <Button outline onClick={(e) => { e.preventDefault(); hide('DeleteChatModal'); }} children="Cancel"/>
                    <Button danger onClick={(e) => { e.preventDefault(); deleteChat(); hide('DeleteChatModal'); }} children="Delete Chat"/>
                </>
            }
        >
            <div className="l-row">
                <div className="l-one-col">
                    <p><strong>{`Are you sure you want to delete ${chat?.name ? (`"` + chat.name + `"`) : "this chat"}?`}</strong></p>
                    <p>Deleting a chat can't be undone, so think carefully! :) </p>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteChatModal;